<template>
  <div class="Index">
    <div class="tw-index-head">
      <div class="tw-index-head-search">
        <van-overlay style="z-index:105" :show="overFlag">
          <van-loading
            type="spinner"
            style="position:absoulte;top:50%;left:50%"
          />
        </van-overlay>
        <div class="tw-index-head-search-left">BUS<br />浙大</div>
        <div class="tw-index-head-search-mid">
          <!-- <el-select
            v-model="search.begin"
            clearable
            filterable
            placeholder="起点"
            class="tw-index-head-search-mid-input"
            @visible-change="handleVisiableChangeClick"
          >
            <el-option
              v-for="item in xlzdList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-input
            v-model="search.begin"
            class="tw-index-head-search-mid-input"
            placeholder="起点"
            clearable
            readonly
            @focus="handleBeginClick"
          ></el-input>
          <i class="iconfont icon-change" @click="handleCommutationClick"></i>
          <el-input
            v-model="search.end"
            class="tw-index-head-search-mid-input"
            placeholder="终点"
            clearable
            readonly
            @focus="handleEndClick"
          ></el-input>
          <!-- <el-select
            v-model="search.end"
            clearable
            filterable
            placeholder="终点"
            @visible-change="handleEndVisiableChangeClick"
            class="tw-index-head-search-mid-input"
          >
            <el-option
              v-for="item in xlzdList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <input
            class="tw-index-head-search-mid-time"
            clearable
            type="text"
            placeholder="选择时间"
            v-model="search.time"
            @focus="handlePickTimeClick"
            @blur="handleLostPickTimeClick"
            readonly
          />
          <div
            class="tw-index-head-search-mid-block"
            @click="handleSearchClick"
          >
            <van-icon
              name="search"
              size="25"
              color="#ffffff"
              style="padding-top: 1px;padding-left: 2px;"
            />
          </div>
        </div>
        <div class="tw-index-head-search-right">
          <div class="timeTable" @click="handleTimeTableClick">
            班车<br />时刻表
          </div>
          <!-- <div @click="handleFavoriteClick">
            <van-icon name="star-o" size="20"></van-icon>
            <div class="tw-index-head-search-right-text">收藏夹</div>
          </div> -->
          <div @click="handleWinterVacationBusClick">
            <van-icon name="star" size="20" color="#3478ff"></van-icon>
            <div class="tw-index-head-search-right-text" style="color: #3478ff;">寒假班车</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="historyFlag"
      style=" height:calc(100% - 84px);"
      @touchmove="handleTouchMoveClick"
    >
      <div class="tw-index-body" ref="indexbody">
        <div id="indexmap" style="z-index:0"></div>
      </div>
      <div class="tw-index-bottom" ref="indexbottom">
        <div
          class="tw-index-bottom-top"
          id="resizeable"
          @touchstart="handletouchstartClick"
          @touchend="handletouchendClick"
        >
          <div class="tw-index-bottom-top-icon">
            <img
              src="../assets/image/station.png"
              class="station-icon"
              alt=""
            />
          </div>
          <div class="tw-index-bottom-top-name" v-if="!listFlag">
            {{ selectSite }}站
          </div>
        </div>
        <div class="tw-index-bottom-body">
          <van-skeleton
            class="listOver"
            title
            avatar
            :row="3"
            v-if="listFlag"
          />
          <div
            class="tw-index-bottom-body-list"
            v-else-if="busInfoList.length > 0"
          >
            <div
              class="tw-index-bottom-body-list-item"
              v-for="(item, index) in busInfoList"
              :key="index"
              @click="handleItemClick(item)"
            >
              <div class="tw-index-bottom-body-list-item-icon">
                <img src="../assets/image/bus.png" class="bus-icon" alt="" />
              </div>
              <div class="tw-index-bottom-body-list-item-linename">
                {{ item.bc_name }}
              </div>
              <div class="tw-index-bottom-body-list-item-starend van-ellipsis">
                <!-- {{ item.start_address }}站<i class="iconfont icon-right_2"></i>
                {{ item.end_address }}站
                <br />
                {{ item.forstudent == 1 ? '对学生开放' : '不对学生开放' }} -->
                {{ item.memo }}
              </div>
              <!-- <div class="tw-index-bottom-body-list-item-beg">
                首：{{ item.start_time }}
              </div>
              <div class="tw-index-bottom-body-list-item-end">
                末：{{ item.arrive_time }}
              </div> -->
              <div
                v-if="
                  item.is_now == 'true' &&
                    item.runBusInfo != null &&
                    item.runBusInfo.length != 0 &&
                    parseInt(item.runBusInfo[0].near_distance) > 0
                "
              >
                <div class="tw-index-bottom-body-list-item-arrive">
                  <span style="color:#3478ff">
                    {{ item.runBusInfo[0].near_distance }}站 </span
                  >后到达
                </div>
                <div class="tw-index-bottom-body-list-item-minute">
                  大约<span style="color:#09a8ee"
                    >{{ item.runBusInfo[0].about_minute }}分钟</span
                  >
                </div>
              </div>
              <div
                class="tw-index-bottom-body-list-item-minute"
                v-if="
                  item.is_now == 'true' &&
                    item.runBusInfo != null &&
                    item.runBusInfo.length != 0 &&
                    parseInt(item.runBusInfo[0].near_distance) <= 0
                "
              >
                已过站
              </div>

              <div
                class="tw-index-bottom-body-list-item-minute"
                v-if="item.is_now == 'false'"
              >
                暂未发车
              </div>
              <div
                class="tw-index-bottom-body-list-item-collection"
                v-if="item.is_favorite == 'false'"
                @click.stop="handleCollectionClick(item)"
              >
                <van-icon name="star" size="15" color="#d6d9e0"></van-icon>
              </div>
              <div
                class="tw-index-bottom-body-list-item-collection"
                v-else
                @click.stop="handleCancelCollectionClick(item)"
              >
                <van-icon name="star" size="15" color="red"></van-icon>
              </div>
            </div>
          </div>
          <van-empty
            v-else
            class="tw-index-bottom-body-list"
            description="暂无班车"
          />
        </div>
      </div>
    </div>
    <!-- <template v-if="!historyFlag">
      <div
        class="tw-index-beginlist"
        style="height: 50%;width: 100%;position: absolute;"
      >
        <div class="tw-index-history-text">站点列表</div>
        <div style="height: calc(100% - 25px);overflow: auto;">
          <div class="tw-index-history-list" v-if="zsStationList.length > 0">
            <div
              class="tw-index-history-list-item"
              v-for="(item, index) in zsStationList"
              :key="index"
            >
              <div
                class="tw-index-history-list-item-name"
                @click.stop="handleBeginItemClick(item.station_alias)"
              >
                {{ item.station_alias }}
              </div>
            </div>
          </div>
          <div
            v-else
            style="text-align:center;font-size:16px;line-height:100px;color: #bfbfbf;"
          >
            无此站点
          </div>
        </div>
      </div>
      <div class="tw-index-history">
        <div class="tw-index-history-text">历史记录</div>
        <div style="height: calc(100% - 25px);overflow: auto;">
          <div class="tw-index-history-list">
            <div
              class="tw-index-history-list-item"
              v-for="(item, index) in historyList"
              :key="index"
            >
              <div
                class="tw-index-history-list-item-name"
                @click.stop="handleBeginItemClick(item.station)"
              >
                {{ item.station }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template> -->
    <van-datetime-picker
      class="timepicker"
      v-if="timeFlag"
      v-model="currentDate"
      type="datetime"
      title="选择时间"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="handleConfirmClick"
      @cancel="handleTimeCancelClick"
    />
    <div class="tw-hide">
      <div class="tw-map-dialog-wrapper" ref="map-dialog">
        <div class="tw-title">{{ mapDialogData.station_alias }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import moment from 'moment'
import _ from 'underscore'
import { Toast } from 'vant'
import {
  getNearStation,
  getBcByStationName,
  addFavorite,
  cancelFavorite,
  getHistory,
  getStationList
} from 'api/indexAPI'

export default {
  name: 'Index',
  data() {
    return {
      historyFlag: true,
      beginFlag: false,
      endFlag: false,
      beginend: true,
      timeFlag: false,
      overFlag: false,
      listFlag: true,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      search: {
        begin: '',
        end: '',
        time: moment(new Date()).format('YYYY-MM-DD HH:mm')
      },
      selectSite: '',
      map: null,
      distance: 1,
      position: {},
      lastMarker: null,
      siteList: [],
      busInfoList: [],
      mapDialogData: {},
      historyList: [],
      stationList: [],
      xlzdList: [],
      zsStationList: [],
      endy: '',
      endx: '',
      startx: '',
      starty: '',
      moveFlag: false,
      sn: '',
      timer: null
    }
  },
  computed: {},
  mounted() {
    if (this.$route.query.type != undefined) {
      this.search.begin = this.$route.query.begin
      this.search.end = this.$route.query.end
    }
    this.getHistory()
    this.getStationList()
    this.initMap()
  },
  methods: {
    //滑动
    handleTouchMoveClick(e) {
      if (e.touches[0].clientY < 110 || e.touches[0].clientY > 580) return
      // if (this.$refs.indexbottom.offsetHeight < 115)
      //   return (this.$refs.indexbottom.style.height = '115px')
      var moveHeight = e.touches[0].clientY - this.starty
      // console.info('e', e.touches[0].clientY, e.touches[0].screenY)
      if (this.moveFlag) {
        this.$refs.indexbottom.style.height = `calc(100% - ${e.touches[0].clientY}px + 30px`
        if (moveHeight > 0) {
          this.$refs.indexbody.style.height = `calc(100% - ${this.$refs.indexbottom.offsetHeight}px`
        }
      }
    },
    //手指按下
    handletouchstartClick(e) {
      // console.info(e)
      this.moveFlag = true
      this.startx = e.touches[0].pageX
      this.starty = e.touches[0].pageY
    },
    //手指松开
    handletouchendClick(e) {
      this.moveFlag = false
    },
    //定时
    getItvelInfo() {
      this.timer = setInterval(() => {
        const params = new URLSearchParams()
        params.append('bid', '')
        params.append('stationName', this.sn)
        getBcByStationName(params).then(res => {
          this.listFlag = false
          this.busInfoList = res.data.data
        })
      }, 30000)
    },
    //头部搜索
    handleSearchClick() {
      if (this.search.begin == '') return Toast('请选择起点')
      if (this.search.end == '') return Toast('请选择终点')

      this.$router.push({
        path: 'cxjg',
        query: {
          start: this.search.begin,
          end: this.search.end,
          time: this.search.time,
          near: this.selectSite
        }
      })
      // }
    },
    //获取所有站点列表
    getStationList() {
      getStationList().then(res => {
        this.stationList = res.data.data
        _.each(res.data.data, item => {
          this.xlzdList.push({ value: item.station_alias })
        })
      })
    },
    //加载地图
    initMap() {
      var _self = this
      this.map = new AMap.Map('indexmap', {
        // mapStyle: "amap://styles/fresh",
        resizeEnable: true,
        zoom: 20
      })
      console.info()
      if (this.$store.state.position.lat !== '') {
        this.overFlag = false
        this.position = this.$store.state.position
        this.addLocation()
        return
      }
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：5s
        buttonPosition: 'RB', //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20) //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        // zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
      })
      // this.map.addControl(geolocation)
      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          _self.onComplete(result)
        } else {
          _self.onError(result)
        }
      })
    },
    onComplete(res) {
      this.position = this.$store.state.position = res.position
      console.info(this.position)
      this.addLocation()
    },
    onError(res) {
      Toast('定位失败!')
    },

    //换向
    handleCommutationClick() {
      this.beginend = !this.beginend
      var mid = ''
      mid = this.search.begin
      this.search.begin = this.search.end
      this.search.end = mid
    },
    //定位打点
    addLocation() {
      // this.map.setFitView()
      this.getNearStation()
    },
    //显示附近的站点
    getNearStation() {
      this.overFlag = false
      const params = new URLSearchParams()
      params.append('lat', this.position.lat)
      params.append('lon', this.position.lng)
      getNearStation(params).then(res => {
        if (res.data.success == true) {
          this.siteList = res.data.data
          this.recentSites(res.data.data)
        }
      })
    },
    //遍历判断最近站点
    recentSites(data) {
      var stationname = ''
      var sn = ''
      var dis = 10000000000
      var list = {}
      for (let i = 0; i < data.length; i++) {
        if (dis > data[i].distance) {
          dis = data[i].distance
          stationname = data[i].station_alias
          sn = data[i].station_alias_no
          list = data[i]
          this.position.lat = data[i].station_lat
          this.position.lng = data[i].station_long
        }
      }
      // console.info('list', list)
      this.selectSite = stationname
      this.sn = sn
      this.getBcByStationName(sn)
      this.addNearStation()
      clearInterval(this.timer)
      this.timer = null
      this.getItvelInfo()
    },

    //根据站点名称获取途经班车信息
    getBcByStationName(val) {
      const params = new URLSearchParams()
      params.append('bid', '')
      params.append('stationName', val)
      getBcByStationName(params).then(res => {
        this.listFlag = false
        this.busInfoList = res.data.data
      })
    },
    //地图打附近站点
    addNearStation() {
      let _self = this
      AMapUI.loadUI(['overlay/SimpleMarker'], function(SimpleMarker) {
        var iconTheme = 'default'
        //内置的样式
        var lngLats = []
        var siteNameLsit = []
        for (let i = 0; i < _self.siteList.length; i++) {
          lngLats.push([
            _self.siteList[i].station_long,
            _self.siteList[i].station_lat
          ])
          siteNameLsit.push([_self.siteList[i].station_alias])
        }
        for (let i = 0, marker, len = lngLats.length; i < len; i++) {
          // if (siteNameLsit[i] == _self.selectSite) {
          if (
            lngLats[i][0] == _self.position.lng &&
            lngLats[i][1] == _self.position.lat
          ) {
            // console.info(lngLats[i], _self.position.lng, _self.position.lat)
            if (siteNameLsit[i][0].length > 6) {
              marker = new SimpleMarker({
                iconTheme: iconTheme,
                iconStyle: {
                  src: require('../assets/image/dqwz.png'),
                  style: {
                    width: '130px',
                    height: '60px'
                  }
                },
                iconLabel: {
                  innerHTML: `<div class='iconText'>${siteNameLsit[i]}站</div>`,
                  style: {
                    color: '#fff', //设置文字颜色
                    margin: '3px',
                    fontSize: '12px'
                  }
                },
                zIndex: 101,
                data: _self.siteList[i],
                map: _self.map,
                position: lngLats[i],
                anchor: 'bottom-center',
                offset: new AMap.Pixel(0, 0)
              })
              _self.map.setCenter(lngLats[i])
            } else {
              marker = new SimpleMarker({
                iconTheme: iconTheme,
                iconStyle: {
                  src: require('../assets/image/dqwz.png'),
                  style: {
                    width: '130px',
                    height: '60px'
                  }
                },
                iconLabel: {
                  innerHTML: `<div class='iconText'>${siteNameLsit[i]}站</div>`,
                  style: {
                    color: '#fff', //设置文字颜色
                    margin: '3px',
                    fontSize: '12px'
                  }
                },
                zIndex: 101,
                data: _self.siteList[i],
                map: _self.map,
                position: lngLats[i],
                anchor: 'bottom-center',
                offset: new AMap.Pixel(0, 0)
              })
              _self.map.setCenter(lngLats[i])
            }
          } else {
            if (siteNameLsit[i][0].length > 6) {
              marker = new SimpleMarker({
                iconTheme: iconTheme,
                iconStyle: {
                  src: require('../assets/image/zyzd.png'),
                  style: {
                    width: '130px',
                    height: '60px'
                  }
                },
                iconLabel: {
                  innerHTML: `<div class='iconText'>${siteNameLsit[i]}站</div>`,
                  style: {
                    color: '#fff', //设置文字颜色
                    margin: '3px',
                    fontSize: '12px'
                  }
                },
                data: _self.siteList[i],
                map: _self.map,
                position: lngLats[i],
                anchor: 'bottom-center',
                offset: new AMap.Pixel(0, 0)
              })
            } else {
              marker = new SimpleMarker({
                iconTheme: iconTheme,
                iconStyle: {
                  src: require('../assets/image/zyzd.png'),
                  style: {
                    width: '130px',
                    height: '60px'
                  }
                },
                iconLabel: {
                  innerHTML: `<div class='iconText'>${siteNameLsit[i]}站</div>`,
                  style: {
                    color: '#fff', //设置文字颜色
                    margin: '3px',
                    fontSize: '12px'
                  }
                },
                data: _self.siteList[i],
                map: _self.map,
                anchor: 'bottom-center',
                position: lngLats[i],
                offset: new AMap.Pixel(0, 0)
              })
            }
          }
          marker._data = _self.siteList[i]

          const markerClick = e => {
            _self.position.lat = marker._data.station_lat
            _self.position.lng = marker._data.station_long
            _self.listFlag = true
            _self.map.clearMap()
            _self.lastMarker = marker
            _self.selectSite = marker._data.station_alias
            _self.getNearStation()
          }
          marker.on('click', markerClick)
        }
      })
    },

    //mark点击高度调整
    heightAdjustment() {
      // $('.tw-index-body').addClass('keep')
      // $('.tw-index-bottom').addClass('keep')
    },
    //收藏夹点击事件
    handleFavoriteClick() {
      this.$router.push({
        path: '/scj',
        query: {
          near: this.selectSite
        }
      })
    },
    //寒假班车点击事件
    handleWinterVacationBusClick() {
      this.$router.push({
        path: '/hjbc',
      })
    },
    //班车时刻表跳转
    handleBcskbClick() {
      this.$router.push({
        path: '/bcskb'
      })
    },
    //item点击事件
    handleItemClick(item) {
      // console.info(item)
      this.$router.push({
        path: '/zdxl/xlxq',
        query: {
          bid: item.bid,
          near: this.selectSite,
          station: this.selectSite,
          sno: this.sn
        }
      })
    },
    //收藏
    handleCollectionClick(item) {
      const params = new URLSearchParams()
      params.append('bid', item.bid)
      params.append('openid', this.$store.state.user.openid)
      addFavorite(params).then(res => {
        if (res.data.success == true) {
          Toast.success('收藏成功!')
          this.getBcByStationName(this.sn)
        } else {
          Toast.fail('收藏失败!')
        }
      })
    },
    //取消收藏
    handleCancelCollectionClick(item) {
      const params = new URLSearchParams()
      params.append('bid', item.bid)
      params.append('openid', this.$store.state.user.openid)
      cancelFavorite(params).then(res => {
        if (res.data.success == true) {
          Toast.success('取消收藏成功!')
          this.getBcByStationName(this.sn)
        } else {
          Toast.fail('取消收藏失败!')
        }
      })
    },

    handlePickTimeClick() {
      this.timeFlag = true
      this.historyFlag = true
    },
    //时间选择框失去焦点
    handleLostPickTimeClick() {
      setTimeout(() => {
        this.timeFlag = false
        this.historyFlag = true
      })
    },
    //获取历史记录
    getHistory() {
      const params = new URLSearchParams()
      params.append('openid', this.$store.state.user.openid)
      params.append('pageSize', '20')
      getHistory(params).then(res => {
        this.historyList = res.data.data
      })
    },
    //时间确认按钮
    handleConfirmClick(value) {
      console.info(value)
      this.search.time = moment(value).format('YYYY-MM-DD HH:mm')
      this.timeFlag = false
    },
    //时间取消按钮
    handleTimeCancelClick() {
      this.timeFlag = false
    },
    //起点获取焦点
    handleBeginClick() {
      this.$router.push({
        path: '/zdlb',
        query: {
          type: 'begin',
          begin: this.search.begin || '',
          end: this.search.end || ''
        }
      })
    },
    //终点获取焦点
    handleEndClick() {
      this.$router.push({
        path: '/zdlb',
        query: {
          type: 'end',
          begin: this.search.begin || '',
          end: this.search.end || ''
        }
      })
    },
    //起点搜索监听
    beginWatch(val) {
      if (val == '') return (this.zsStationList = this.stationList)
      this.zsStationList = _.filter(this.stationList, item => {
        return item.station_alias.indexOf(val) >= 0
      })
    },
    //终点搜索监听
    endWatch(val) {
      if (val == '') return (this.zsStationList = this.stationList)
      this.zsStationList = _.filter(this.stationList, item => {
        return item.station_alias.indexOf(val) >= 0
      })
    },
    //下拉框出现/隐藏时触发
    handleVisiableChangeClick(val) {
      setTimeout(() => {
        ;(this.historyFlag == val) == true
          ? (this.historyFlag = !val)
          : (this.historyFlag = val)

        this.beginFlag = val
        this.endFlag = !val
      })
    },
    //下拉框出现/隐藏时触发终点
    handleEndVisiableChangeClick(val) {
      setTimeout(() => {
        ;(this.historyFlag == val) == true
          ? (this.historyFlag = !val)
          : (this.historyFlag = val)

        this.endFlag = val
      })
    },
    //点击高度变化
    handleadjustClick() {
      console.info(this.$refs.indexbottom.offsetHeight)
      if (this.$refs.indexbottom.offsetHeight < 399) {
        this.$refs.indexbottom.style.height = '75%'
      } else this.$refs.indexbottom.style.height = '35%'
    },
    // 时刻表跳转
    handleTimeTableClick() {
      // const url =
      //   'http://www.news.zju.edu.cn/ydxw/2021/0108/c20989a2242497/pagem.htm'
      // window.open(url, '_self')
      this.$router.push('/skb')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    // 'search.begin': {
    //   handler(newName, oldName) {
    //     this.beginWatch(newName)
    //   }
    // }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.Index {
  position: relative;
}
.van-search {
  padding: 0;
  height: 100%;
}
#indexmap {
  height: 100%;
  z-index: 3;
}

.icon-right_2 {
  font-size: 10px;
}

.icon-search {
  font-size: 24px;
  color: #0b84f5;
  margin: 10px 0 0 10px;
}

.timepicker {
  z-index: 101;
  height: 32%;
  width: 100%;
  position: absolute;
  bottom: 0px;
}
.tw-hide {
  display: none;
}

.listOver {
  z-index: 105;
  // height: calc(100% - 55px);
  box-sizing: border-box;
  padding: 10px;
}

.station-icon {
  width: 30px;
  height: 30px;
  padding-top: 10px;
}

.bus-icon {
  width: 15px;
  height: 10px;
  padding-left: 7px;
}

.timeTable {
  margin: 2px;
  height: 34px;
  line-height: 17px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background-color: #0089f1;
  cursor: pointer;
  border-radius: 10px;
}

.amap-simple-marker-label{
  margin: 4px 4px 4px 4px !important;
  font-size: 12px !important;
}
</style>
